module.exports = ":host {\n  height: 100%;\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/datawarehouse/components/data-warehouse-entity-list/data-warehouse-entity-list.component.scss
// module id = ./src/app/datawarehouse/components/data-warehouse-entity-list/data-warehouse-entity-list.component.scss
// module chunks = main